import { HintTypeEnum } from '@nankai/online/constants';

export default {
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '请输入订购信息',
      seat: '请选择座位',
      start: '{{time}}出发',
      confirm: '座位确认',
      bookingConfirm: '※仅在支付完成且预订完成后，座位才会正式确认。'
    },
    button: {
      back: '回退',
      next: '下一步',
      change: '变更'
    },
    confirmChange: {
      title: '您的预订将更改如下。',
      before: '变更前',
      after: '变更后',
      label: {
        trainName: '列车',
        date: '日期',
        time: '时间',
        seat: '座位',
        seatWithCar: '座位（{{carNo}}号车厢）'
      }
    },
    selectSeatType: {
      title: '选位方法',
      auto: '电脑选位',
      manual: '自行选位'
    },
    station: {
      date: '乘车日',
      startStation: '出发站',
      endStation: '抵达站',
      startStationTip: '请选择出发站',
      endStationTip: '请选择抵达站'
    },
    hintType: {
      [HintTypeEnum.OutOfAvailableTerm]:
        '所选日期尚未开放预订。（仅可预订1个月内的车次。）',
      [HintTypeEnum.EndOfService]:
        '暂无可购买的列车。<br />请确认列车运行信息。'
    },
    train: {
      header: '请选择小火车',
      emptySeat: '空座位',
      trainLabel: '{{trainName}}{{trainServiceNo}}号'
    },
    carriage: {
      carriageCar: '{{carNo}}号车厢',
      directionUpTitle: '↑ 往难波方向',
      directionDownTitle: '↑ 往高野山方向',
      car1Notice1: '【请注意】2、4、23、27号为无窗座位。',
      car1Notice2: '由于乘务员室一侧为墙壁，因此无法观赏前方景色。'
    },
    wheelchairConfirm: {
      title: '您已选择轮椅专用座位',
      content: '本座位为轮椅使用者专用座位。请确认以下事项：',
      notice1: '本座位仅供预计以轮椅前来的乘客使用。',
      notice2: '一般乘客请勿使用本座位。',
      confirmText: '是否要继续选择？',
      cancel: '取消',
      confirm: '确定'
    }
  },
  error: {
    invalidParams: '指定的条件有误。请从头重新操作',
    lineIdInvalid: '未选择线路。请从头重新操作',
    productIdInvalid: '选择的车厢类型不正确。 请您从头开始重新操作',
    forbidden: '此操作不允许。请从头重新操作',
    seatChangeCountExceeded: '座席变更次数限制为2次',
    notFound: '找不到页面。请从头重新操作',
    system: '系统错误。 请稍后再试'
  }
};
